const solarPanels = [
  {
    question: "How do solar panels work?",
    answer:
      "Solar panels convert sunlight into electricity using photovoltaic (PV) cells<IN_CITY_ZIP>. That electricity powers your home, and any excess can be stored or exported to the utility grid depending on your system design.",
  },
  {
    question: "How much can I save with solar panels?",
    answer:
      "Savings vary based on your system size, utility rates, and energy usage<IN_CITY_ZIP>. Most homeowners reduce electric bills by 40% to 70% — and some eliminate their bill entirely with full offset systems.",
  },
  {
    question: "Do I need permits to install solar panels?",
    answer:
      "Yes. Solar panel installations<IN_CITY_ZIP> require permits from the city and utility interconnection approvals. Modern Build handles the entire permitting process to ensure full compliance and fast approval.",
  },
  {
    question: "How long does it take to install solar panels?",
    answer:
      "Installation usually takes 1 to 3 days<IN_CITY_ZIP>. The full timeline, including design, permitting, and utility approval, typically spans 3 to 6 weeks depending on your city and utility company.",
  },
  {
    question: "What types of solar systems do you offer?",
    answer:
      "We install grid-tied, hybrid, and off-grid solar systems<IN_CITY_ZIP> using premium monocrystalline panels, microinverters, and battery storage like Tesla Powerwall and Enphase Encharge.",
  },
  {
    question: "Will solar panels work during a power outage?",
    answer:
      "Standard grid-tied systems automatically shut off during outages for safety. To keep your power on<IN_CITY_ZIP>, we recommend adding battery storage, which enables backup power during blackouts.",
  },
  {
    question: "Are there incentives or rebates for going solar?",
    answer:
      "Yes. Most homeowners qualify for the Federal Solar Tax Credit (ITC), and many also receive California rebates or local utility incentives<IN_CITY_ZIP>. We’ll help you apply for all available programs.",
  },
  {
    question: "Do solar panels increase my home’s value?",
    answer:
      "Yes. Homes with solar panels<IN_CITY_ZIP> typically sell faster and at higher prices. Buyers value lower electric bills, and solar upgrades are seen as a premium home improvement.",
  },
  {
    question: "How much do solar panels cost?",
    answer:
      "Costs depend on your system size, energy goals, roof structure, and storage options<IN_CITY_ZIP>. Most systems range from $15,000 to $30,000 before incentives. We offer custom quotes and flexible financing.",
  },
];

export default solarPanels;
